function part(key, label, done, total) {
    return total > 0 ? { key, label, ratio: Math.min(1, Math.max(0, done / total)) } : null;
}
/**
 * How far along an event is, as the average of the signals it actually has:
 * tasks done, RSVPs answered, vendors paid and the client's share paid. A
 * signal with nothing behind it (no tasks, no guests, no expenses) is left out
 * rather than counted as 0% or 100%, so a new event is not reported as ready
 * or as failing.
 */
export function computeEventReadiness(overview) {
    const { tasks, guests, money } = overview;
    const parts = [
        part('tasks', 'Tasks done', tasks.done, tasks.total),
        part('rsvps', 'RSVPs in', guests.total - guests.pending, guests.total),
        part('vendorsPaid', 'Vendors paid', money.paidToVendors, money.totalCost),
        part('clientPaid', 'Client paid', money.clientPaid, money.clientPaid + money.clientBalanceDue),
    ].filter((p) => p !== null);
    if (parts.length === 0)
        return { score: null, parts, weakest: null };
    const score = Math.round((parts.reduce((s, p) => s + p.ratio, 0) / parts.length) * 100);
    const weakest = parts.reduce((w, p) => (p.ratio < 1 && (!w || p.ratio < w.ratio) ? p : w), null);
    return { score, parts, weakest };
}
//# sourceMappingURL=eventReadiness.js.map